import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Empregador } from '../../api.service';
import { ServicoAutenticacao } from '../../core/auth/servico-autenticacao';
import { ModuloGerencial, rotaDoModuloGerencial } from '../../core/rotas/navegacao-menu-gerencial';
import { ServicoIdentidadeMarca } from '../../shared/servico-identidade-marca';
import { ServicoEmpregadorAdministrativo } from '../empregador/servico-empregador-administrativo';

@Injectable({ providedIn: 'root' })
export class ServicoSessaoGerencial {
  empregadores: Empregador[] = [];
  empregadorSelecionado = '';

  constructor(
    private readonly servicoAutenticacao: ServicoAutenticacao,
    private readonly servicoEmpregador: ServicoEmpregadorAdministrativo,
    private readonly servicoIdentidadeMarca: ServicoIdentidadeMarca,
    private readonly roteador: Router
  ) {}

  get usuario() {
    return this.servicoAutenticacao.usuarioLogado;
  }

  get identificacao() {
    return this.usuario?.nome || '';
  }

  get nomeEmpresa() {
    return this.identidade.nome;
  }

  get logoEmpresa() {
    return this.identidade.logo;
  }

  get iniciaisEmpresa() {
    return this.identidade.iniciais;
  }

  carregar() {
    this.servicoEmpregador.listar().subscribe({
      next: empregadores => {
        this.empregadores = empregadores;
        this.empregadorSelecionado = this.empregadorSelecionado
          || this.usuario?.empregadorId
          || this.usuario?.empregador?.id
          || empregadores[0]?.id
          || '';
      }
    });
  }

  abrir(modulo: string) {
    this.roteador.navigateByUrl(rotaDoModuloGerencial(modulo as ModuloGerencial));
  }

  sair() {
    this.servicoAutenticacao.sair();
    this.roteador.navigate(['/login']);
  }

  private get identidade() {
    return this.servicoIdentidadeMarca.montar(
      this.empregadores,
      this.empregadorSelecionado,
      this.servicoEmpregador.novoEmpregador()
    );
  }
}
